import L from "leaflet";

const canvasPrototype = L.Canvas.prototype;
const mapPrototype = L.Map.prototype;

if (!canvasPrototype._sarfinderRedrawPatched) {
  const redraw = canvasPrototype._redraw;

  canvasPrototype._redraw = function () {
    if (this._redrawRequest) {
      L.Util.cancelAnimFrame(this._redrawRequest);
      this._redrawRequest = null;
    }

    if (!this._map || !this._ctx) {
      this._redrawBounds = null;
      return;
    }

    return redraw.call(this);
  };

  Object.defineProperty(canvasPrototype, "_sarfinderRedrawPatched", {
    value: true,
  });
}

if (!mapPrototype._sarfinderZoomLifecyclePatched) {
  const onZoomTransitionEnd = mapPrototype._onZoomTransitionEnd;

  // An inertia drag (Map.Drag) queues panBy on the next frame; if the map is
  // removed in between, panBy reaches for the deleted pane.
  const panBy = mapPrototype.panBy;

  mapPrototype.panBy = function (offset, options) {
    if (!this._mapPane) {
      return this;
    }

    return panBy.call(this, offset, options);
  };

  mapPrototype._onZoomTransitionEnd = function () {
    if (!this._mapPane) {
      this._animatingZoom = false;
      return;
    }

    return onZoomTransitionEnd.call(this);
  };

  Object.defineProperty(mapPrototype, "_sarfinderZoomLifecyclePatched", {
    value: true,
  });
}
